import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useModalContext } from '@dataswift/shared';
import DevelopersPage from '../../styles/templates/DeveloperPage';
import ProjectList from '../../components/Projects/ProjectList';
import { ProjectPageHeader } from '../../components/Projects/ProjectListHeader';
import { getApps } from '../../redux/applications/actions/AppActions';
import { selectProjects } from '../../redux/selectors/projects';
import { CreateAppModal } from '../../components/Modals';

type PropsType = {
  path?: string;
  default?: boolean;
};

const ProjectsPage: React.FC<PropsType> = () => {
  const dispatch = useDispatch();
  const projects = useSelector(selectProjects);
  const { openModal, isOpen } = useModalContext();

  useEffect(() => {
    dispatch(getApps());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DevelopersPage blurred={isOpen}>
      <ProjectPageHeader />
      <ProjectList
        projects={projects || []}
        onNewProject={() =>
          openModal({
            open: true,
            component: CreateAppModal,
          })
        }
      />
    </DevelopersPage>
  );
};

export default ProjectsPage;
